/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import ModalConfirmation from '../../../../components/Modal/ConfirmationModal';
import useDebounce from '../../../ServicePanel/components/QueueContent/components/Contact/ContactActiveModal/hooks/useDebaunce';
import ToggleSwitch from '../../../../components/ToggleSwitch/ToggleSwitch';
import SimpleHeader from '../../../../components/Headers/SimpleHeader';
import Pagination from '../../../../components/Pagination';
import ReactLoader from '../../../../components/Loader';
import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../../assets/styles/table_custom_style';

import HandleAccountsModal from '../components/HandleAccountModal';

import CustomerPortfolioService from '../service';
import { DEFAULT_PAGE_SIZE } from 'views/SLA/utils';

const CustomerPortfolioList = () => {
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState(1);
  const [showDisabled, setShowDisable] = useState(false);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const [customerPortfolios, setCustomerPortfolios] = useState([]);
  const [quantity, setQuantity] = useState(0);
  const [idResource, setIdResource] = useState();

  const debouncedSearchValue = useDebounce(searchValue, 1000);

  useEffect(() => {
    getCustomerPortfolios();
  }, []);

  const getCustomerPortfolios = useCallback(
    (selectedPage = 1, q = '') => {
      const params = {
        page: selectedPage || activePage,
        size: DEFAULT_PAGE_SIZE,
        showDisabled,
        q
      };
      CustomerPortfolioService.getCustomerPortfolio(params)
        .then((res) => {
          const customerPortfolios = res.data.data.content;
          const quantity = res.data.data.quantity;
          setCustomerPortfolios(customerPortfolios);
          setQuantity(quantity);

          if (quantity === 0) {
            toast.info('Nenhuma categoria de cliente encontrada!', {
              autoClose: 3000,
              closeOnClick: true
            });
          }

          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao listar as categorias dos clientes!', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    },
    [activePage, showDisabled]
  );

  useEffect(() => {
    getCustomerPortfolios(activePage, debouncedSearchValue);
  }, [activePage, debouncedSearchValue, getCustomerPortfolios]);

  const handlePageChange = useCallback(
    (activePage) => {
      setActivePage(activePage);
      getCustomerPortfolios(activePage, debouncedSearchValue);
    },
    [getCustomerPortfolios]
  );

  const deleteCustomerPortfolio = (id) => {
    const usrLogin = localStorage.getItem('login');
    CustomerPortfolioService.deleteCustomerPortfolio(id, usrLogin)
      .then((res) => {
        const { data } = res;
        getCustomerPortfolios();
        setActivePage(1);
        toast.success(data.message, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch((error) => {
        const { data } = error.response;
        toast.error(data.message || 'Erro ao deletar categoria de cliente!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getCustomerPortfolios();
        setActivePage(1);
      });
  };

  const goToPage = useCallback(
    (newPage) => {
      handlePageChange(newPage);
    },
    [handlePageChange]
  );

  const handleEnableCustomerPortfolio = async (id, usrLogin) => {
    await CustomerPortfolioService.enable(id, usrLogin)
      .then(() => {
        toast.success('Categoria de Cliente habilitada com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch((error) => {
        const msg = error?.response?.data?.message;
        toast.error(msg || 'Erro ao habilitar Categoria de Cliente', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handleDisableCustomerPortfolio = async (id, usrLogin) => {
    await CustomerPortfolioService.disable(id, usrLogin)
      .then(() => {
        toast.success('Categoria de Cliente desabilitada com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch((error) => {
        const msg = error?.response?.data?.message;
        toast.error(msg || 'Erro ao desabilitar Categoria de Cliente', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const toggleCustomerPortfolioStatus = useCallback(
    ({ id, isActive }) => {
      const usrLogin = localStorage.getItem('login');
      try {
        if (isActive) {
          handleDisableCustomerPortfolio(id, usrLogin);
        } else {
          handleEnableCustomerPortfolio(id, usrLogin);
        }
      } catch (error) {
        const msg = error?.response?.data?.message;
        toast.error(
          msg ||
            `Erro ao ${
              isActive ? 'desabilitar' : 'habilitar'
            } Categoria de Cliente`
        );
      }
      setTimeout(() => {
        goToPage(1);
      }, 300);
    },
    [handleDisableCustomerPortfolio, handleEnableCustomerPortfolio, goToPage]
  );

  const controlDelete = (id) => {
    setIdResource(id);
    setOpenModalConfirmation(true);
  };

  const handleShowDisableds = (value) => {
    setShowDisable(value);
    if (value === false) setActivePage(1);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/customer-portfolio/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Categoria dos Clientes</h3>
                </CardHeader>
                <Row className="mt-3 mx-2">
                  <Col md="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Pesquisar"
                        type="text"
                        onChange={(event) => setSearchValue(event.target.value)}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="4" className="text-right mt-2">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={showDisabled}
                          onChange={() => handleShowDisableds(!showDisabled)}
                        />
                        <span>Mostrar desabilitados</span>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <ToolkitProvider
                  data={customerPortfolios}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Link to={'/admin/customer-portfolio/form/' + row.id}>
                            <Button color="info" size="sm">
                              <li className="fas fa-user-edit"></li>
                            </Button>
                          </Link>
                        );
                      }
                    },
                    {
                      dataField: 'accounts',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Contas',
                      formatter: (_, row) => {
                        return (
                          <>
                            <Button
                              color="info"
                              size="sm"
                              title="Contatos"
                              onClick={() => {
                                setIdResource(row.id);
                                setIsAccountModalOpen(true);
                              }}
                            >
                              <li className="fas fa-address-card"></li>
                            </Button>
                          </>
                        );
                      }
                    },
                    {
                      dataField: 'habilitar/desabilitar',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Habilitar/Desabilitar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <ToggleSwitch
                            checked={row.enabled}
                            id={row.id}
                            onChange={() =>
                              toggleCustomerPortfolioStatus({
                                id: row.id,
                                isActive: row.enabled
                              })
                            }
                          />
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Deletar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="danger"
                            size="sm"
                            disabled={row.enabled}
                            onClick={() => controlDelete(row.id)}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deleteCustomerPortfolio}
        message={'Tem certeza que deseja excluir essa Categoria de Cliente?'}
      />
      <HandleAccountsModal
        isModalOpen={isAccountModalOpen}
        onModalToggle={setIsAccountModalOpen}
        unmountOnClose={true}
        customerPortfolioId={idResource}
      />
    </>
  );
};

export default CustomerPortfolioList;
